export const creditTypes = {
    PERSONAL:"شخصی",
    SPONSOR:"شرکتی",
    INCOME:"فروش",
    NON_WITHDRAWABLE:"اعتبار خرید"

}
